<template>
    <div>
        <div class="flex-page-content flex-container">
            <div class="flex-body body-scroll">
                <div class="container-fluid">

                    <div class="container-centered-s py-4">

                        <h5>{{ onboardingApplication.company.name }}</h5>
                        <h3>Resident School District</h3>

                        <form @submit.prevent="onSubmit" class="mt-2">
                            <form-errors :errors="formErrors" :errorsHtml="formErrorsHtml" />

                            <div class="form-row">
                                <div class="col">
                                    <form-input v-model="formData.school_district_choice_idx" :errors="errors.school_district_choice_idx" type="radio" :options="schoolDistrictChoiceOptions" label="Please select the school district in which you live."/>
                                </div>
                            </div>

                            <alert-box type="caution">
                            {{ schoolDistrictDisclaimer }}
                            </alert-box>

                            <div class="row mb-2 d-flex align-items-center">
                                <div class="col">
                                    <router-link v-if="previousPage" :to="previousPage">Back</router-link>
                                </div>

                                <div class="col text-right">
                                    <button class="btn btn-primary">Continue</button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import FormMixin from '@/mixins/Form'
import api from '@/api'
import WizardMixin from './WizardMixin'

export default {
    mixins: [FormMixin, WizardMixin],
    props: ['onboardingApplication', ],
    computed: {
        schoolDistrictChoiceOptions() {
            const result = []
            this.onboardingApplication.geocode_data['school_district_choices']['school_district_choices'].forEach((c, idx) => {
                result.push({text: c['SchoolDistName'].toUpperCase(), value: idx})
            })
            return result
        },
        schoolDistrictDisclaimer() {
            let state = this.onboardingApplication.geocode_data['state']
            return this.schoolDistrictDisclaimers[state] || this.schoolDistrictDisclaimers['default']
        }
    },
    data() {
        return {
            formRules: {
                'school_district_choice_idx': {
                    presence: {
                        allowEmpty: false,
                        message: "is required"
                    },
                }
            },
            formLabels: {
                'school_district_choice_idx': 'School District Selection',
            },
            formErrorsHtml: [],
            formData: this.makeFormData(),
            schoolDistrictDisclaimers: {
                'default': 'This selection may affect your taxes. If you have questions regarding your school district, please verify with a trusted resource, such as a state or local government office.',
                'OH': 'This selection may affect your taxes. If you have questions regarding your school district, please verify with your County Auditor or contact the Department of Taxation.'
            }
        }
    },
    methods: {
        makeFormData() {
            return {
                action: 'give-address-school-district',
                school_district_choice_idx: this.onboardingApplication.school_district_choice_idx,
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            api.patch(`/me/onboarding/${this.onboardingApplication.id}/onboarding-application`, this.getFormData()).then((resp) => {
                this.$emit('updated', resp)
                this.$emit('next')
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.errors = errors
                this.formErrorsHtml = errors.__all__
                this.onError()
                this.$store.dispatch('STOP_LOADING')
            })
        },
        reset: function() {
            this.errors = {}
            this.formErrorsHtml = []
            this.formData = this.makeFormData()
        },
    },
}
</script>
